import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96b2e56c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-custom-checkbox" }
const _hoisted_2 = ["value", "checked"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "32",
  height: "32",
  viewBox: "-4 -4 39 39",
  "aria-hidden": "true",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    class: "cb-bg",
    width: "35",
    height: "35",
    x: "-2",
    y: "-2",
    stroke: "currentColor",
    fill: "none",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("polyline", {
    class: "cb-cm",
    points: "4,14 12,23 28,5",
    stroke: "transparent",
    "stroke-width": "4",
    fill: "none"
  })
], -1))
const _hoisted_4 = { class: "cb-contents" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      value: _ctx.modelValue,
      checked: _ctx.checked,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 40, _hoisted_2),
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}